var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardWithTitle',{attrs:{"title":_vm.$t('R.LIT_IntellectualProperty'),"no-card":""}},[_c('div',{staticClass:"position-relative"},[(_vm.showTerritorySelector)?_c('div',{attrs:{"id":"TerritorySelector"}},[_c('TerritorySelector')],1):_vm._e(),_c('NavTabs',{attrs:{"tabs":_vm.tabs}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }